declare const window: { gtagPlanne: Function };

export const track = (event: string, payload: any = null) => {
  if (typeof window !== 'undefined' && window.gtagPlanne) {
    window.gtagPlanne('event', event, payload);
  }
};
